export default {
  "The race is coming soon. Please stay tuned for updates.":"Giải chạy sắp diễn ra. Hãy tiếp tục theo dõi để cập nhật.",
  "Please read the Terms & Conditions and Privacy Statement before checking the button.":
    "Please read the Terms & Conditions and Privacy Statement before checking the button.", // 协议没选
  "It's working too fast. Please try again in 10 seconds.":
    "It's working too fast. Please try again in 10 seconds.", // 10秒后才能二次验证
  "Invitation code": "Mã giới thiệu", // 1003
  "Invitation code error": "Mã giới thiệu bị lỗi", // 失败提示用于else
  // 注册页开始
  Name: "Tên",
  Age: "Tuổi",
  "Please do not register if you are under 18 years old":
    "Xin vui lòng không đăng ký nếu bạn dưới 18 tuổi",
  Gender: "Giới",
  Male: "tính Nam",
  Female: "Nữ",
  Other: "Khác",
  Email: "Email",
  "Phone number of emergency contact person":
    "Số điện thoại người liên hệ khẩn cấp",
  "Please share your professional experience":
    "Vui lòng chia sẻ trải nghiệm chạy của bạn",
  "Previous race certificate within 3 years": "Các chứng nhận chạy trong 3 năm",
  "Your information is incorrect": "Thông tin của bạn không chính xác",
  "Your registration is successful. Please check more race information on your personal center.":
    "Bạn đã đăng ký thành công. Vui lòng cập nhật thêm thông tin về giải chạy ở địa chỉ liên hệ cá nhân.",
  "Your registration has been successfully submitted and is currently under review. Since this is a professional race, your qualification needs to undergo evaluation. Please check the status on your personal center.":
    "Đơn đăng ký của bạn đã được nộp thành công và hiện đang chờ xử lý. Do đây là cuộc đua chuyên nghiệp, vì vậy năng lực của bạn cần được xem xét và đánh giá. Vui lòng kiểm tra trạng thái đăng ký tại địa chỉ liên hệ cá nhân.",
  // 注册页结束
  // 报名成功开始
  Pending: "Đang chờ xử lý",
  "Congratulations!": "Chúc mừng bạn!",
  // 报名成功结束
  advertisement: {
    title: "Xiaomi Smart Band 9",
    desc: "Giới thiệu về Xiaomi Smart Band 9",
  },
  common: {
    "Personal page": "Địa chỉ liên hệ",
    "Sign out": "Đăng xuất",
    "Sign in": "Đăng nhập",
    professionalRace: "Giải chuyên nghiệp",
    runForFun: "Giải nghiệp dư",
    introduction: "Giới thiệu Xiaomi POP Run 2024",
    termsAndCondition: "Điều khoản & Quy định",
    privacyStatement: "Chính sách Quyền riêng tư",
    title: "Xiaomi POP Run 2024",
    mile: "10KM",
    mile2: "",
    btn: {
      confirm: "Xác nhận",
    },
  },
  home: {
    btn: {
      runNow: "Run Now",
    },
  },
  register: {
    disclaimer:
      "Thông báo miễn trừ trách nhiệm: Trước khi tham gia cuộc đua, xin vui lòng tự kiểm tra sức khỏe một cách toàn diện để xác nhận rằng bạn đáp ứng các tiêu chuẩn cần thiết.",
    submit: "Nộp",
  },
  details: {
    area: {
      p: "Professional Race Running time:",
      runTime: "Run for Fun Running time:",
    },
    card: {
      countdownToRegistrationStarts: "Đếm ngược giờ đăng ký",
      countdownToRegistrationEnds: "Cổng đăng ký sẽ đóng trong...",
      Days: "Ngày",
      Hours: "Giờ",
      Minutes: "Phút",
    },
    btn: {
      register: "Đăng ký",
      runNow: "Run Now",
      enrollmentIsFull: "Số lượng đăng ký đã đầy",
      registrationIsClosed: "Đóng đăng ký tất cả các cự li",
    },
    desc: {
      invitationCodeRegistration: "Giai đoạn đăng kí code mời tham gia",
    },
  },
  review: {
    title: "Bạn không thể thay đổi thông tin đã được xác nhận",
    more: "Thêm",
    text: "Tắt thông báo",
    btn: {
      agree: "Đồng ý",
      disagree: "Không đồng ý",
    },
  },
  end: {
    logout: "Log out",
    infoHeader: {
      title: "POP Run 2024",
      runTime: "Running Time：",
      btn: {
        runNow: "Run Now",
        pending: "Đang chờ xử lý",
        registered: "Đã đăng ký",
        rejected: "Application failed",
        waiting: "Đang đợi xác nhận chính thức",
        unfortunately: "Rất tiếc, đơn đăng ký của bạn đã bị từ chối",
      },
    },
    application: "Đơn đăng ký",
    checkMore: {
      about: "Tìm hiểu thêm tại đây:",
    },
    participationHistory: {
      header: "Lịch sử tham gia",
      noHistory: "No history",
      h2: "Xiaomi Pop Run { year }-Professional Race",
    },
    share: {
      name: "Tên:",
      country: "Quốc gia:",
      download: "Tải xuống",
      shareOn: "Chia sẻ trên: ",
      content:
        "với #XiaomiPOPRun2024. Mời thêm bạn bè cùng tham gia đường đua!",
      description:
        "Invite more friends to join the race and feel passion beyond limits!",
    },
  },
  footer: {
    copyright: "Copyright©2016-{year} Xiaomi.com, All Rights Reserved",
  },
  dialog: {
    logOut: {
      content: "Please check if you want to log out",
      confirm: "Xác nhận",
      cancle: "Cancle",
    },
    countrySelect: {
      headerTitle: "Country",
      headerContent:
        "Country-City name The following list displays the hosting cities for the Xiaomi POP Run 2024",
      rowNow: "Run Now",
      footerContent:
        "*For some countries, the registration will be redirected to an external website",
    },
  },
};
